import api from '@/api'

class Laporan {
  cekPassPub (nomorPembayaran, nomorPendaftar) {
    return new Promise((resolve, reject) => {
      api.post('/v2/pembayaran/cek_password/pub', {
        nomor_pembayaran: nomorPembayaran,
        nomor_pendaftar: nomorPendaftar
      })
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            resolve(responseData.data)
          }
        })
        .catch(e => {
          reject(e.response)
        })
    })
  }
}

export default new Laporan()



// WEBPACK FOOTER //
// ./src/helper/laporan.js